import {SVGProps} from 'react';

import {COLORS} from '@/styles/colors';

export const FlipIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 13}
    height={props.height ?? 12}
    viewBox={`0 0 ${props.width ?? 13} ${props.height ?? 12}`}
    fill="none"
    {...props}>
    <path
      d="M5 6c0 .83.67 1.5 1.5 1.5S8 6.83 8 6s-.67-1.5-1.5-1.5S5 5.17 5 6zm2 0c0 .275-.225.5-.5.5A.501.501 0 016 6c0-.275.225-.5.5-.5s.5.225.5.5z"
      fill={props.fill ?? COLORS.CONTENT_LIGHT_TERTIARY}
    />
    <path
      d="M4.5 5V4H3.045c.69-1.195 1.98-2 3.455-2 1.86 0 3.425 1.28 3.87 3h1.03c-.465-2.28-2.48-4-4.9-4-1.635 0-3.09.79-4 2.005V2h-1v3h3zM8.5 7v1h1.455c-.69 1.195-1.98 2-3.455 2a4.007 4.007 0 01-3.87-3H1.6c.465 2.28 2.48 4 4.9 4 1.635 0 3.09-.79 4-2.005V10h1V7h-3z"
      fill={props.fill ?? COLORS.CONTENT_LIGHT_TERTIARY}
    />
  </svg>
);
